import {
  EntityType,
  FAIconName,
  FireflyButton,
  ChakraHStack,
  ModalV2,
  Text,
} from '@equip.health/ui';
import { MergeConfirmationActionType } from '~/lib/constants/inquiry.constants';
import { mergeDuplicatesConfirmationActionConfig } from '~/lib/util/inquiry.util';

interface MergeDuplicatesConfirmationProps {
  action: MergeConfirmationActionType;
  entityType: EntityType;
  id: string;
  isLoading: boolean;
  onSubmit: () => void;
  onClose: () => void;
  onBack: () => void;
}

export const MergeDuplicatesConfirmation = ({
  action,
  entityType,
  id,
  isLoading,
  onSubmit,
  onClose,
  onBack,
}: MergeDuplicatesConfirmationProps) => {
  const TOPLEVEL_ID = `${id}__confirmation-modal`;

  const actionConfig = mergeDuplicatesConfirmationActionConfig(entityType);
  const {
    submitText,
    confirmationTitle,
    confirmationDescription,
    submitButtonIcon,
  } = actionConfig[action] ?? actionConfig.default;

  return (
    <ModalV2
      footerContent={
        <ChakraHStack justifyContent="space-between" width="100%">
          <FireflyButton
            id={`${TOPLEVEL_ID}__back`}
            isDisabled={isLoading}
            leftIcon={FAIconName.chevronLeftRegular}
            onClick={onBack}
            variant="secondary"
          >
            Back
          </FireflyButton>
          <FireflyButton
            id={`${TOPLEVEL_ID}__submit`}
            isDisabled={isLoading}
            leftIcon={submitButtonIcon}
            onClick={onSubmit}
            variant="primary"
          >
            {submitText}
          </FireflyButton>
        </ChakraHStack>
      }
      id={`${TOPLEVEL_ID}__modal`}
      isOpen
      onClose={onClose}
      size="5xl"
      title={confirmationTitle}
    >
      <Text id={`${TOPLEVEL_ID}__confirmation-description`}>
        {confirmationDescription}
      </Text>
    </ModalV2>
  );
};
